'use client';

import { Toast as BaseToast } from '@base-ui/react/toast';
import clsx from 'clsx';
import { Icon } from '@/components/icons/svg-icons';

import { ToastStyle } from './toast.types';
import { CdnImg } from '@/features/cdn-img';

export const Toast = () => {
	const { toasts } = BaseToast.useToastManager();

	return (
		<BaseToast.Portal>
			<BaseToast.Viewport className="toast-viewport">
				{toasts.map((toast: BaseToast.Root.ToastObject) => {
					const isWcPromotion2026 = toast.data?.style === ToastStyle.WcPromotion2026;
					const isWcSpinInfo = toast.data?.style === ToastStyle.WcSpinInfo;

					const handleToastClick = () => {
						toast.data?.onClick?.();
					};

					return (
						<BaseToast.Root
							key={toast.id}
							toast={toast}
							className={clsx(
								'base-toast', {
									'base-toast--wc2026-promotion': isWcPromotion2026,
									'base-toast--wc2026-spin-info': isWcSpinInfo,
								})}
							swipeDirection={['up', 'right']}
							onClick={handleToastClick}
						>

							{isWcPromotion2026 ? (
								<div className="base-toast__icon">
									<Icon name="ticket-success-line" />
								</div>
							) : null}

							{isWcSpinInfo ? (
								<div className="base-toast__icon">
									<CdnImg src="/images/promotion/worldcup2026/icon-spin.svg" alt="spin-info" />
								</div>
							) : null}

							<BaseToast.Content className="base-toast__content">
								<BaseToast.Title
									className="base-toast__title"
									render={<div></div>}
								/>
								<BaseToast.Description
									className="base-toast__description"
									render={<div></div>}
								/>
							</BaseToast.Content>

							{isWcPromotion2026 ? (
								<>
									<div className="wc2026-promotion-toast-point">
										<div className="wc2026-promotion-toast-point__icon"></div>
										+{toast.data?.point}
									</div>
									<div className="wc2026-promotion-toast-tag"></div>
								</>
							) : null}

							{isWcSpinInfo ? (
								<>
									<div className="wc2026-spin-info-toast-action">
										Go
									</div>
									<div className="wc2026-spin-info-toast-tag">
										<div className="wc2026-spin-info-toast-tag__icon"></div>
									</div>
								</>
							) : null}
						</BaseToast.Root>
					);
				})}
			</BaseToast.Viewport>
		</BaseToast.Portal>
	);
};